import { useEffect, useState } from "react";

export default function useIsDesktop(breakpointPx = 768) {
  const query = `(min-width: ${breakpointPx}px)`;

  const [isDesktop, setIsDesktop] = useState(() =>
    window.matchMedia(query).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setIsDesktop(e.matches);

    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, [query]);

  return isDesktop;
}